
export default function HeaderValidation({onRefresh}) {
   
  return (
    <div>
       {/* <!--column--> */}
        <div className="col-xl-12">
            <div className="kanban-header">
                <div className="left-title">
                  <div>
                    <span className="breadcrumb-main text-uppercase">Validation</span>
                  </div>
                </div>
                <div className="right-title">
                    <div className="title-content">
                         <button
                          className="btn btn-primary btn-new-order"
                          onClick={onRefresh}
                          title="Rafraîchir"
                        >Rafraichir</button>   
                    </div>
                </div>	
            </div>
        </div>
    </div>
  )
}
